module.exports = __webpack_public_path__ + "entry-150bfe9b/Background_01_7x2_a-863d5f3ac02162689146d27bef34552b.svg";